import { useLayoutEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TNullable } from '@/shared/types';
import { Wrapper } from '@/shared/ui/Wrapper';
import { PageLoader } from '@/shared/ui/PageLoader';
import { useAuth, useUserData } from '@/entities/User';
import { useGlobalStore } from '@/entities/GlobalStore';
import { AuthType } from '../model/types';
import { useSendLogLogin } from '../query/useSendLogLogin';
import { LOG_IN_PARAM, REGISTRATION_PARAM } from '../model/data';
import { useSendLogRegister } from '../query/useSendLogRegister';

export const AuthPage = () => {
    const reason = useRef<TNullable<'login' | 'register'>>(null);
    const { setIsRegistrationAllowed } = useGlobalStore();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams('');

    const authType = searchParams.get('auth_type') as AuthType;
    const userId = searchParams.get('user_id');

    const { mutate: logLogin } = useSendLogLogin();
    const { mutate: logRegister } = useSendLogRegister();
    const { mutate: getUserData } = useUserData({
        onSuccess: () => {
            if (reason.current === 'register') {
                logRegister();
                setIsRegistrationAllowed(true);
                navigate('/?scrollTo=RegistrationFormContainer');
            }

            if (reason.current === 'login') {
                logLogin();
                navigate('/lk');
            }
        },
        onError: () => {
            navigate('/');
        },
    });

    const { mutate: auth } = useAuth({
        onSuccess: () => {
            getUserData();
        },
    });

    useLayoutEffect(() => {
        if (!searchParams.size || !authType || !userId) {
            navigate('/');

            return;
        }

        if (authType === LOG_IN_PARAM) {
            reason.current = 'login';
            auth({ id: userId });
        }

        if (authType === REGISTRATION_PARAM) {
            reason.current = 'register';
            getUserData();
        }
    }, []);

    return (
        <Wrapper>
            <PageLoader />
        </Wrapper>
    );
};
